module.exports = __webpack_public_path__ + "img/logo.5a2665d6.png";